(() => {
  if (window.hmgViewportGallery) return;
  window.hmgViewportGallery = true;
  const instances = new Map();

  function attach(gallery) {
    if (instances.has(gallery) || !gallery.dataset.desktopLayout.includes('thumbnail')) return;
    const wrapper = gallery.closest('.product__media-wrapper');
    const thumbnails = gallery.querySelector('[id^="GalleryThumbnails-"]');
    const header = document.getElementById('shopify-section-header');
    const desktop = window.matchMedia('(min-width: 750px)');
    let frame;
    const px = value => Number.parseFloat(value) || 0;
    const set = (name, value) => {
      const next = `${Math.round(value)}px`;
      if (gallery.style.getPropertyValue(name) !== next) gallery.style.setProperty(name, next);
    };

    function measure() {
      frame = null;
      if (!gallery.isConnected || !wrapper) return;
      if (!desktop.matches) {
        gallery.style.removeProperty('--hmg-gallery-sticky-top');
        return;
      }
      if (!gallery.getClientRects().length) return;
      let stickyTop = 16;
      if (header && !header.classList.contains('shopify-section-header-hidden')) {
        const style = getComputedStyle(header);
        if (style.position === 'sticky' || style.position === 'fixed') {
          stickyTop += header.offsetHeight + Math.max(0, px(style.top));
        }
      }
      const viewport = window.visualViewport?.height || window.innerHeight;
      const galleryHeight = gallery.getBoundingClientRect().height;
      set('--hmg-gallery-sticky-top', Math.min(stickyTop, viewport - galleryHeight - 16));
    }

    function schedule() {
      if (!frame) frame = requestAnimationFrame(measure);
    }
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
    const headerObserver = header ? new MutationObserver(schedule) : null;
    function syncObservers() {
      observer?.disconnect();
      headerObserver?.disconnect();
      if (desktop.matches) {
        [wrapper, gallery, thumbnails, header].filter(Boolean).forEach(el => observer?.observe(el));
        headerObserver?.observe(header, {attributes: true, attributeFilter: ['class', 'style']});
      }
      schedule();
    }
    window.addEventListener('resize', schedule, {passive: true});
    window.visualViewport?.addEventListener('resize', schedule, {passive: true});
    window.addEventListener('load', schedule, {once: true});
    desktop.addEventListener('change', syncObservers);
    instances.set(gallery, () => {
      cancelAnimationFrame(frame);
      observer?.disconnect();
      headerObserver?.disconnect();
      window.removeEventListener('resize', schedule);
      window.visualViewport?.removeEventListener('resize', schedule);
      window.removeEventListener('load', schedule);
      desktop.removeEventListener('change', syncObservers);
      instances.delete(gallery);
    });
    syncObservers();
  }

  function init(root) {
    root.querySelectorAll('media-gallery[data-hmg-viewport-gallery]').forEach(attach);
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((dispose, gallery) => {
      if (event.target.contains(gallery)) dispose();
    });
  });
})();
